module.exports = __webpack_public_path__ + "static/media/back_of_left_hand.89431abd.svg";